// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://stpgsqlapi.mmisafev2.com',
  mapId:"5187921bcaec3421",
  apiKey:"AIzaSyAqsdSPc302QtVOVxNlHb4aktWJmIp3XQk",
  firebase: {
    apiKey: "AIzaSyC-5YheFBTDK5MJskEcRpOQra4uo3JcYL8",
    authDomain: "evman-95d29.firebaseapp.com",
    projectId: "evman-95d29",
    storageBucket: "evman-95d29.appspot.com",
    messagingSenderId: "825950403668",
    appId: "1:825950403668:web:a328d447dab3ecc066c1c1",
    vapidKey: "BMwPs6w--814GO70_nBmJf2owdxGUmX50v4Be6auPN_dtzG7pUMWkyCn3wKsc5e0XSQbpPdGD79QqC6akp0b07g"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
